import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ISuppliAuthentication,
  SubscriptionAllowedFeatures, // eslint-disable-line no-unused-vars
  SystemFeatures,
} from "isuppli-react-components";
import { getAllSubscriptionsAllowedFeatures, getUserBasicDetails } from "../../http/core/core";
import { setSubscriptionAllowedFeatures, setUserBasicDetails } from "../../store/actions";
import { checkHttpStatus } from "../../http/httpService";
// eslint-disable-next-line no-unused-vars
import { ReduxState } from "../../store/ReduxState";

const UserDataLoader = ({
  onLoadingDone,
  children,
}: {
  onLoadingDone: () => void,
  children: React.ReactNode
}) => {
  // use ref so that useEffect only loads once
  const loadingDoneHandler = useRef<() => void>(onLoadingDone);
  const allowedFeatures = useSelector((s: ReduxState) => s.userBasicDetails?.allowedFeatures);
  const subscriptionsAllowedFeaturesInfo = useSelector(
    (state: ReduxState) => (state.subscriptionsAllowedFeatures as SubscriptionAllowedFeatures[])
  );
  useEffect(() => {
    loadingDoneHandler.current = onLoadingDone;
  }, [onLoadingDone]);

  const dispatch = useDispatch();
  useEffect(() => {
    const loadDetails = async () => {
      try {
        const details = await getUserBasicDetails({ bypassSessionExpiryCheck: true });
        // eslint-disable-next-line no-undef
        details.allowedFeatures = BigInt(details.allowedFeaturesString);
        dispatch(setUserBasicDetails(details));
        const subscriptionAllowedFeatures = await getAllSubscriptionsAllowedFeatures();
        dispatch(setSubscriptionAllowedFeatures(subscriptionAllowedFeatures));

        if (loadingDoneHandler.current != null) {
          loadingDoneHandler.current();
        }
      } catch (error) {
        if (checkHttpStatus(error, 401)) {
          // user is not authenticated, redirect to login
          window.location.href = `/account/login?returnUrl=${encodeURIComponent(window.location.href)}`;
        }
      }
    };

    loadDetails();
  }, [dispatch, loadingDoneHandler]);

  return (
    <ISuppliAuthentication
      allowedFeatures={allowedFeatures ?? SystemFeatures.None}
      subscriptionFeaturesInfo={subscriptionsAllowedFeaturesInfo}
    >
      {children}
    </ISuppliAuthentication>
  );
};

export default UserDataLoader;
